import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const servicesLinks = t('footer.servicesLinks', { returnObjects: true });
  const firmLinks = t('footer.firmLinks', { returnObjects: true });
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/5 bg-[#07120F]/85 backdrop-blur-sm">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-7 h-7 rounded-full bg-[#5FE0C8] grid place-items-center">
                <span className="w-2 h-2 rounded-full bg-[#07120F]" />
              </span>
              <span className="font-display text-[18px]">Mint Property Advisory</span>
            </div>
            <p className="text-[14px] text-[#9A9A8E] leading-relaxed max-w-[380px]">
              {t('footer.tagline')}
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#7A7A7A] mb-4">{t('footer.servicesTitle')}</div>
            <ul className="space-y-3 text-[14px] text-[#C9C5B8]">
              <li><a href="/#services" className="hover:text-[#5FE0C8] transition-colors">{servicesLinks.search}</a></li>
              <li><a href="/#services" className="hover:text-[#5FE0C8] transition-colors">{servicesLinks.pricing}</a></li>
              <li><a href="/#services" className="hover:text-[#5FE0C8] transition-colors">{servicesLinks.diligence}</a></li>
              <li><a href="/#services" className="hover:text-[#5FE0C8] transition-colors">{servicesLinks.lease}</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#7A7A7A] mb-4">{t('footer.firmTitle')}</div>
            <ul className="space-y-3 text-[14px] text-[#C9C5B8]">
              <li><a href="/#process" className="hover:text-[#5FE0C8] transition-colors">{firmLinks.process}</a></li>
              <li><a href="/#assets" className="hover:text-[#5FE0C8] transition-colors">{firmLinks.assets}</a></li>
              <li><a href="/#sold" className="hover:text-[#5FE0C8] transition-colors">{firmLinks.sold}</a></li>
              <li><a href="/#contact" className="hover:text-[#5FE0C8] transition-colors">{firmLinks.contact}</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#7A7A7A] mb-4">{t('footer.contactTitle')}</div>
            <p className="text-[14px] text-[#C9C5B8] leading-relaxed">
              <a href="mailto:info@mintpropertyadvisory.com.au" className="hover:text-[#5FE0C8] transition-colors">info@mintpropertyadvisory.com.au</a>
            </p>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="border-t border-white/5 pt-10">
          <div className="font-display text-[11vw] md:text-[14vw] leading-[0.85] tracking-tight text-[#0E2A24] select-none">
            MINT.<span className="text-[#5FE0C8]">advisory</span>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-[#7A7A7A]">
          <div>{t('footer.legal', { year })}</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-[#5FE0C8] inline-flex items-center gap-1">{t('footer.privacy')} <ArrowUpRight className="w-3 h-3" /></Link>
            <a href="#" className="hover:text-[#5FE0C8] inline-flex items-center gap-1">{t('footer.terms')} <ArrowUpRight className="w-3 h-3" /></a>
            <a href="#" aria-label="Instagram (coming soon)" title="Instagram (coming soon)" className="hover:text-[#5FE0C8] inline-flex items-center gap-1">{t('footer.instagram')} <ArrowUpRight className="w-3 h-3" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
